import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { doFilterValuesMatch } from "../helpers";
/**
 * Filter results - Adds to current filter value
 *
 * Will trigger new search
 *
 * @param name String field name to filter on
 * @param value String field value to filter on
 * @param type String (Optional) type of filter to apply
 */

export default function addFilter(name, value) {
  var _console;
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "all";
  // eslint-disable-next-line no-console
  if (this.debug) (_console = console).log.apply(_console, ["Search UI: Action", "addFilter"].concat(Array.prototype.slice.call(arguments)));
  var filters = this.state.filters;
  var existingFilter = filters.find(function (f) {
    return f.field === name && f.type === type;
  }) || {};
  var allOtherFilters = filters.filter(function (f) {
    return f.field !== name || f.type !== type;
  }) || [];
  var existingFilterValues = existingFilter.values || [];
  var newFilterValues = existingFilterValues.find(function (existing) {
    return doFilterValuesMatch(existing, value);
  }) ? existingFilterValues : existingFilterValues.concat(value);
  this._updateSearchResults({
    current: 1,
    filters: [].concat(_toConsumableArray(allOtherFilters), [{
      field: name,
      values: newFilterValues,
      type: type
    }])
  });
}